import { render, staticRenderFns } from "./AdminAcademicSubcategories.html?vue&type=template&id=aed40edc&scoped=true&"
import script from "./AdminAcademicSubcategories.vue?vue&type=script&lang=js&"
export * from "./AdminAcademicSubcategories.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcademicSubcategories.scss?vue&type=style&index=0&id=aed40edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed40edc",
  null
  
)

export default component.exports